import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const LinkToSomewhere = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.73598 2C2.81383 2 2.06628 2.74755 2.06628 3.66969V12.3303C2.06628 13.2525 2.81383 14 3.73598 14H12.264C13.1862 14 13.9337 13.2525 13.9337 12.3303V8.58352C13.9337 8.22885 13.6462 7.94133 13.2915 7.94133C12.9369 7.94133 12.6494 8.22885 12.6494 8.58352V12.3303C12.6494 12.5431 12.4768 12.7156 12.264 12.7156H3.73598C3.52317 12.7156 3.35066 12.5431 3.35066 12.3303V3.66969C3.35066 3.45689 3.52317 3.28438 3.73598 3.28438H6.79315C7.14782 3.28438 7.43534 2.99686 7.43534 2.64219C7.43534 2.28752 7.14782 2 6.79315 2H3.73598Z"
        fill="currentColor"
      />
      <path
        d="M9.50994 3.16786C9.50742 2.8132 9.79288 2.52364 10.1475 2.52112L12.585 2.50375C13.0569 2.50038 13.4406 2.88294 13.4388 3.35479L13.429 5.80057C13.4276 6.15524 13.1389 6.44161 12.7843 6.44019C12.4296 6.43878 12.1432 6.15012 12.1447 5.79545L12.149 4.70055L7.93448 8.87393C7.68246 9.12349 7.27585 9.1215 7.02629 8.86948C6.77674 8.61746 6.77873 8.21085 7.03075 7.9613L11.2353 3.79778L10.1567 3.80546C9.80203 3.80799 9.51247 3.52253 9.50994 3.16786Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default LinkToSomewhere;
